import React from 'react'
import "./comment.css";
import { PermMedia, Label, Room, EmojiEmotions } from "@mui/icons-material"
import { useContext, useRef, useState,useEffect } from "react";
import axiosInstance from '../../config';
import { Link } from "react-router-dom";
import SocialContext from "../../context/SocialContext";
import Showcomment from "../showcomment/Showcomment";

export default function Comment({ postId, comments,setnumberOfComment }) {
    const { user, setshowalert, setalertType, setalertmessage } = useContext(SocialContext);
    // const PF = process.env.REACT_APP_PUBLIC_FOLDER;
    const PF = "https://socialshub.netlify.app/images/";
    const [newcomment, setnewcomment] = useState(false);
    const [loading, setloading] = useState(false);
    const [allcomments, setallcomments] = useState([]);
    const [commentDeleted, setcommentDeleted] = useState(false);

    // function for sort the comments according to dates
    useEffect(() => {
        setloading(true);
        comments.reverse();
        setallcomments(comments);
        setloading(false);
    }, [postId]);

    
    
    const comment = useRef();
    let today;

    const commentfun = async (event) => {
        event.preventDefault();
        try {
            if (comment.current.value != "") {
                today = new Date();
                comments=allcomments;
                await axiosInstance.put(`/api/posts/${postId}/comment`, { userId: user._id, comments: comment.current.value, uniqueKey: today });
                comments.unshift({ 'userId': user._id, 'comments': comment.current.value, 'uniqueKey': today });
                setallcomments(comments);
                setnewcomment(true);
                comment.current.value = "";
                setTimeout(() => {
                    setnewcomment(false);
                }, 1000);
                setnumberOfComment(allcomments.length);
            }
        } catch (error) {
            console.log("inside comment", error);
        }
    }

    const onclickfun = () => {
        if (comment.current.value == "") {
            setshowalert(true);
            setalertType("warning");
            setalertmessage("Plese write something and try again")
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        }
    }

    const [postdisable, setpostdisable] = useState(true);
    const onchangefun = () => {
        if (comment.current.value == "")
            setpostdisable(true);
        else
            setpostdisable(false);
    }

    return (
        <>
            <div className='comment'>
                <div className="comment-profile">
                    <div className="comment-img">
                        <Link style={{'textDecoration':'none'}} to={"/profile/" + user._id}>
                            <img src={user.profilePic ? user.profilePic : PF + "person/noprofile.jpeg"} />
                        </Link>
                    </div>
                    <form className="comment-input" onSubmit={commentfun}>
                        <input type="text"
                            ref={comment}
                            placeholder='Write a comment....'
                            onChange={onchangefun}
                        />
                        <button onClick={onclickfun}>Post</button>
                    </form>
                </div>
            </div>
            
            {
                !loading && allcomments.map((c) => (
                    <Showcomment key={c.userId} allcomments={allcomments} setallcomments={setallcomments} setnumberOfComment={setnumberOfComment} postId={postId} userId={c.userId} comment={c.comments} uniqueKey={c.uniqueKey} />
                ))
            }
        </>
    )
}
